import React from 'react';
import PropTypes from 'prop-types';
import { ErrorShape } from '../../utils/shapes';

const NonFieldErrors = ({ error, className }) => {
    if (!error) return null;

    let errors = [];
    if (typeof error === 'string') {
        errors = [
            {
                code: 'unknown',
                message: error,
            },
        ];
    } else if (error instanceof Array) {
        errors = error;
    }
    if (errors.length < 1) {
        return null;
    }
    return errors.map((fieldError) => (
        <div className={className} key={fieldError.message}>
            {fieldError.message}
        </div>
    ));
};

NonFieldErrors.propTypes = {
    error: ErrorShape,
    className: PropTypes.string,
};

NonFieldErrors.defaultProps = {
    error: null,
    className: 'alert alert-danger', // Default for bootstrap4
};

export default NonFieldErrors;



// WEBPACK FOOTER //
// ./src/components/inputs/NonFieldErrors.js